{
  "DATA_ASSISTANT": {
    "TITLE": "Assistant de données",
    "NEW_CONVERSATION": "+ Nouveau",
    "LOADING": "Chargement...",
    "LOADING_MESSAGES": "Chargement des messages...",
    "THINKING": "Réflexion en cours...",
    "UNTITLED": "Conversation sans titre",
    "NO_CONVERSATIONS": "Aucune conversation pour le moment. Cliquez sur « + Nouveau » pour commencer.",
    "EMPTY_STATE": "Sélectionnez une conversation ou créez-en une nouvelle pour commencer.",
    "SEND": "Envoyer",
    "PLACEHOLDER": "Que puis-je trouver pour vous ?",
    "SHOW_SQL": "Afficher le SQL",
    "NO_ROWS": "Aucune ligne renvoyée.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Supprimer la conversation",
    "DELETE_CONFIRM_DESCRIPTION": "Êtes-vous sûr de vouloir supprimer cette conversation ? Cette action est irréversible.",
    "DELETE_CONFIRM_YES": "Supprimer",
    "CHAT": "Chat",
    "REPORTS": "Rapports",
    "SAVE_TO_REPORT": "Enregistrer dans un rapport",
    "NEW_REPORT": "Nouveau rapport",
    "REPORT_NAME": "Nom du rapport",
    "NO_REPORTS": "Aucun rapport enregistré pour le moment",
    "REPORTS_EMPTY_STATE": "Sélectionnez un rapport ou créez-en un nouveau.",
    "REPORT_SAVED": "Enregistré dans le rapport",
    "DELETE_REPORT_CONFIRM": "Supprimer le rapport",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Êtes-vous sûr de vouloir supprimer ce rapport ? Tous les éléments enregistrés seront supprimés.",
    "DELETE_ITEM_CONFIRM": "Retirer l'élément",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Êtes-vous sûr de vouloir retirer cet élément du rapport ?",
    "EXPORT_CSV": "Exporter en CSV",
    "REFRESH": "Actualiser",
    "QUERY_RUNNING": "Exécution de la requête...",
    "QUERY_FAILED": "Échec de la requête",
    "AUTO_REFRESH": "Actualisation automatique",
    "AUTO_REFRESH_NONE": "Manuel",
    "AUTO_REFRESH_30S": "30 secondes",
    "AUTO_REFRESH_1M": "1 minute",
    "AUTO_REFRESH_5M": "5 minutes",
    "AUTO_REFRESH_10M": "10 minutes",
    "EDIT_MESSAGE": "Modifier le message",
    "RENAME_REPORT": "Renommer le rapport",
    "RENAME_ITEM": "Renommer l'élément",
    "MOVE_UP": "Déplacer vers le haut",
    "MOVE_DOWN": "Déplacer vers le bas",
    "COLLABORATORS": {
      "BUTTON": "Collaborateurs",
      "TITLE": "Collaborateurs du rapport",
      "DESCRIPTION": "Choisissez les agents et les équipes qui peuvent consulter ce rapport.",
      "AGENTS": "Agents",
      "TEAMS": "Équipes",
      "SELECT_AGENTS": "Sélectionner des agents",
      "SELECT_TEAMS": "Sélectionner des équipes",
      "SAVE": "Enregistrer",
      "SAVED": "Collaborateurs mis à jour",
      "SAVE_FAILED": "Échec de la mise à jour des collaborateurs"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Rapports"
}
